<template>
  <el-dialog title="查看报价"
             width="900px"
             :visible.sync="visibleValue"
             :close-on-press-escape="false"
             :close-on-click-modal="false"
             :modal-append-to-body="true"
             :append-to-body="true"
             @closed="closedCallback">
    <div v-loading="loadingList">
      <p class="margin-bottom">
        计费方式：
        <template v-if="details.chargeType === 1">按照里程区间计费</template>
        <template v-else-if="details.chargeType === 2">按照里程数计费</template>
        <template v-else>{{ details.chargeType || "-" }}</template>
      </p>
      <el-alert
        v-if="details.billingUnit === 'PLTS' || details.billingUnit === 'PK'"
        class="margin-bottom"
        :title="`温馨提示：卡板规格：可拼容重 ${PLTSInfo.usableTon}T；可拼容积 ${PLTSInfo.usableCbm} CBM； 长(${PLTSInfo.l}M)  宽（${PLTSInfo.w}M） 高（${PLTSInfo.h}M ）`"
        type="warning"
        effect="dark"
      />
      <quotation-table-list
        :list="list"
        :table-header-list="tableHeaderList"
        :partitionType="details.partitionType"
        :is-low-elimination="details.isLowElimination"
      />
      <div style="text-align: center;margin-top: 20px;">
        <el-button style="width: 120px;" size="small" @click="closedDialog">关闭</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import {mixinsDialog} from "my-element-mixins";
import QuotationTableList
  from "@/components/QuotationManagement/components-productQuotation/usePlatformQuotation/quotationTableList";
import {mapFromArrayToObject} from "@/assets/js/utils";
import {isObject} from "my-tools-kit";

export default {
  name: "usePlatformQuotationViewQuotation",
  components: {QuotationTableList},
  mixins:[mixinsDialog],
  props:{
    id:[String,Number],
  },
  data(){
    return {
      details:{
        // billingUnit:"",//计费单位：KG、CBM、PK（皮卡）、PLTS（卡板）
        // chargeType:"",//计费模式：1 按照里程区间计费 2 按照里程数计费
      },
      // 列表
      loadingList:false,
      tableHeaderList:[],
      list:[],
    }
  },
  computed:{
    PLTSInfo(){
      return isObject(this.details.containerDTO) ? this.details.containerDTO : {};
    },
  },
  watch:{
    isShow(val){
      if(val) setTimeout(()=>{
        this.getList()
      },100);
    }
  },
  methods:{
    /**
     * 关闭回调
     */
    closedCallback() {
      this.$emit('closed');
      this.resetData();
    },
    /**
     * 重置数据
     */
    resetData(){
      this.loadingList = false;
      this.list = [];
      this.tableHeaderList = [];
      this.details = {};
    },
    /**
     * 获取列表
     */
    getList(id = this.id){
      let url = `/api/smartQuotedPrice/getSmartQuotedPriceInfo/${id}`;
      let data = {};
      this.loadingList = true;
      this.axios.get(url,{params:data})
        .then(res=>{
          res = isObject(res.data) ? res.data : {};
          if(res.code !== 200) return Promise.reject(new Error(res.message));
          return res;
        })
        .then(res => {
          this.loadingList = false;
          let details = res.data||{};
          let list = details.pricePartitionDetail||[];
          let tableHeaderList = details.intervalSchemeDetailHeaderList || [];
          let billingUnit = details.billingUnit||"";
          tableHeaderList = tableHeaderList.map((item,index)=>{
            let label = ``;
            if(item.segmentEnd){
              label = `${item.segmentStart}—${item.segmentEnd}${billingUnit}`
            }else{
              label = `${item.segmentStart}${billingUnit}以上`
            }
            return {
              label,
              valueKey:`price${index+1}`
            }
          })
          this.list = list;
          this.tableHeaderList = tableHeaderList;
          this.details = details;
        })
        .catch(res=>{
          this.loadingList = false;
          this.list = [];
          this.tableHeaderList = [];
          this.details = {};
        })
    },
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/QuotationManagement/components-productQuotation/usePlatformQuotation/viewQuotation.vue